import { render, staticRenderFns } from "./SuspendedBanner.vue?vue&type=template&id=5c6e5bbc"
import script from "./SuspendedBanner.vue?vue&type=script&lang=js"
export * from "./SuspendedBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports